
import Vue from "vue"
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator"
import ChangeRateWidget from "@/superannuation/ChangeRateWidget.vue"

@Component({components: {ChangeRateWidget}})
export default class IconBannerWidget extends Vue {
  @Prop()
  icon: string
}
